<template>
  <v-container fluid class="box-container ma-0 pa-0 customscroll" justify="space-between" :style="isWithSmallWidth ? 'overflow-y: auto;' : ''" style="width: 100%; height: 100%; z-index: 1">
    <!-- <v-row v-if="isLoading" align="center" justify="center" class="row-header ma-4 pa-0">
      <v-progress-linear :indeterminate="true" class="ma-2 pa-0"></v-progress-linear>
      <div dense style="text-align: center; width: 100%" class="ma-0 pa-0 subtitle-2" :value="true" color="default">{{ TR.DataProcessingPleaseWait }}</div>
    </v-row> -->
    <v-card :class="(isWithSmallWidth ? 'row-content-horizontal-scroll' : 'row-content') + (isOnMobile ? ' ma-1 pa-0' : ' ma-2 pa-0')">
      <div class="box-container">
        <DeviceStatus class="row-content" ref="refDeviceStatus" :showLegend="true" :showSortSearch="true" :hasEuroChange="hasEuroChange" :showBlockedOnly="false" :showOldDevices="true" :showZeroTurnovers="showDeviceZeroTurnovers" :datatype="datatype" />
      </div>
    </v-card>
    <v-row class="row-header ma-0 pa-0">
      <v-col cols="12" xl="4" lg="4" sm="4" xs="12" :class="isOnMobile ? 'ma-0 pa-1' : 'ma-0 pa-2'">
        <v-card class="mx-auto elevation-5" width="100%" height="100%">
          <div class="box-container">
            <div class="row-header custom_hover_shadow" style="cursor: pointer" @click="goToSalesGrid">
              <v-row class="ma-0 pa-0 py-1" align="center" justify="center">
                <span :class="isWithSmallWidth ? 'subtitle' : 'subtitle'">
                  {{ TR.TotalTurnover }}
                  <v-icon right>mdi-arrow-right</v-icon>
                </span>
              </v-row>
            </div>
            <v-divider></v-divider>
            <div class="row-content pa-2 subtitle-2">
              <v-row class="ma-0 pa-0" align="center" justify="center" style="height: 100%">
                <v-col class="ma-0 pa-0">
                  <v-row class="ma-0 pa-0" style="width: 100%">
                    <span class="text-left">{{ TR.ForTheDay + " (" + TR.Sales + "):" }}</span>
                    <span class="flex-grow-1 text-right">{{ sumsData.daily.toFixed(2) + " " + TR.MoneyAbbreviation }}</span>
                  </v-row>
                  <v-row class="ma-0 pa-0" style="width: 100%" v-if="!hasEuroChange">
                    <span class="text-left">{{ TR.ForTheWeek + ":" }}</span>
                    <span class="flex-grow-1 text-right">{{ (sumsData.weekly + sumsData.daily).toFixed(2) + " " + TR.MoneyAbbreviation }}</span>
                  </v-row>
                  <v-row class="ma-0 pa-0" style="width: 100%">
                    <span class="text-left">{{ TR.ForTheMonth + " (" + TR.ZReports + "):" }}</span>
                    <span class="flex-grow-1 text-right">{{ sumsData.monthly.toFixed(2) + " " + TR.MoneyAbbreviation }}</span>
                  </v-row>
                  <v-row v-if="!isVeryBigUser" class="ma-0 pa-0" style="width: 100%">
                    <span class="text-left">{{ TR.ForTheYear + " (" + TR.MonthlyReports + "):" }}</span>
                    <span class="flex-grow-1 text-right">{{ sumsData.yearly.toFixed(2) + " " + TR.MoneyAbbreviation }}</span>
                  </v-row>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-card>
      </v-col>

      <v-col cols="12" xl="4" lg="4" sm="4" xs="12" :class="isOnMobile ? 'ma-0 pa-1' : 'ma-0 pa-2'">
        <v-card class="mx-auto elevation-5" width="100%" height="100%">
          <div class="box-container">
            <div class="row-header custom_hover_shadow" style="cursor: pointer" @click="goToChartDaily">
              <v-row class="ma-0 pa-0 py-1" align="center" justify="center">
                <span :class="isWithSmallWidth ? 'subtitle' : 'subtitle'">
                  {{ TR.TurnoverByDays }}
                  <v-icon right>mdi-arrow-right</v-icon>
                </span>
              </v-row>
            </div>
            <v-divider></v-divider>
            <div class="row-content">
              <v-sheet color="transparent" height="100%">
                <v-sparkline height="100%" style="min-height: 100%" :padding="16" :smooth="32" :gradient="graphsGradiend" :labels="dailyData_labels" :value="dailyData_values" auto-draw auto-line-width :show-labels="true" stroke-linecap="round"></v-sparkline>
              </v-sheet>
            </div>
          </div>
        </v-card>
      </v-col>

      <v-col cols="12" xl="4" lg="4" sm="4" xs="12" :class="isOnMobile ? 'ma-0 pa-1' : 'ma-0 pa-2'">
        <v-card class="mx-auto elevation-5" width="100%" height="100%">
          <div class="box-container">
            <div class="row-header custom_hover_shadow" style="cursor: pointer" @click="goToChartHourly">
              <v-row class="ma-0 pa-0 py-1" align="center" justify="center">
                <span :class="isWithSmallWidth ? 'subtitle' : 'subtitle'">
                  {{ TR.TurnoverByHoursForTheDay }}
                  <v-icon right>mdi-arrow-right</v-icon>
                </span>
              </v-row>
            </div>
            <v-divider></v-divider>
            <div class="row-content">
              <v-sheet color="transparent" height="100%">
                <v-sparkline height="100%" style="min-height: 100%" :value="hourlyData_values" :labels="hourlyData_labels" :gradient="graphsGradiend" :padding="16" auto-line-width :show-labels="true" type="bar"></v-sparkline>
              </v-sheet>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import DeviceStatus from "../components/Devices/DeviceStatus";
import DataManager, { ErrorMessage } from "../js/DataManager";
import Translation from "../js/Translation";
import bus, { g_Dialog, g_euroDate, TR } from "../main";

export default {
  components: {
    DeviceStatus,
  },
  data() {
    return {
      hasEuroChange: false,
      isRefreshing: false,
      showDeviceZeroTurnovers: true,
      lastSelectedElementIdx: -1,
      datatype: null,
      message: null,
      title: "",
      weeklyData_labels: [],
      weeklyData_values: [],

      dailyData_labels: [],
      dailyData_values: [],

      hourlyData_labels: [],
      hourlyData_values: [],

      sumsData: {
        daily: 0,
        weekly: 0,
        monthly: 0,
        yearly: 0,
      },
      onfocus: false,
      TR: TR,
    };
  },
  methods: {
    isVeryBigUser() {
      return DataManager.isVeryBigUser();
    },
    setFocus(on) {
      this.onfocus = on;
      // this.$nextTick(() => {
      if (this.$refs.refDeviceStatus) this.$refs.refDeviceStatus.setFocus(on);
      // });
    },
    serviceContractExpireWarn(date) {
      return new Date(date).getTime() < new Date().addDays(14).getTime();
    },
    goToSalesGrid() {
      this.$router.push({ path: "/" + TR.Locale + "/gridSales" });
    },
    goToChartDaily() {
      var start = new Date().getDateWithoutTime().addDays(-6);
      var end = new Date().getDateWithoutTime().addDays(1).addMilliseconds(-1);
      DataManager.DataType.sales_reports.datesFromTo = [start, end];
      this.$router.push({ path: "/" + TR.Locale + "/chartDaily" });
    },
    goToChartHourly() {
      var start = new Date().getDateWithoutTime();
      var end = new Date().getDateWithoutTime().addDays(1).addMilliseconds(-1);
      DataManager.DataType.sales_by_hourTR.price.datesFromTo = [start, end];
      this.$router.push({ path: "/" + TR.Locale + "/chartHourlyPrice" });
    },
    // goTo(routeName) {
    //   this.$router.push({ name: routeName });
    //   // bus.$emit(bus.EVENT_AddTab_In_MainContent, routeName);
    // },
    refreshData() {
      if (this.isRefreshing) return;
      this.isRefreshing = true;
      g_Dialog
        .show(g_Dialog.dialog_types.loader, null, {
          message: TR.DataProcessingPleaseWait,
        })
        .then(() => {
          var now = new Date().getDateWithoutTime();

          if (TR.Locale == Translation.bg.Locale && now.getMonday().getTime() < g_euroDate.getTime() && now.getTime() > g_euroDate.getTime()) {
            this.hasEuroChange = true;
          }
          if (DataManager.isVeryBigUser()) {
            this.hasEuroChange = true;
          }

          this.sumsData.yearly = 0;
          this.sumsData.monthly = 0;
          this.sumsData.daily = 0;
          this.sumsData.weekly = 0;
          this.dailyData_labels = [];
          this.dailyData_values = [];
          this.weeklyData_labels = [];
          this.weeklyData_values = [];
          this.hourlyData_labels = [];
          this.hourlyData_values = [];

          this.$nextTick(() => {
            var dateFrom = new Date(now.getFullYear(), 0);
            var dateTo = new Date();
            DataManager.loadData(
              DataManager.DataType.monthly,
              (error) => {
                if (error.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
                  var m0 = DataManager.getData(DataManager.DataType.monthly);

                  if (!this.isVeryBigUser()) {
                    this.sumsData.yearly = m0
                      .filter((d) => d.date >= dateFrom)
                      .map((s) => s.Sum)
                      .sum();
                  }

                  DataManager.loadData(DataManager.DataType.daily, (err2) => {
                    if (err2.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
                      var dateFrom = now.addDays(-40);
                      var today00h = now.getDateWithoutTime();
                      var d0 = DataManager.getData(DataManager.DataType.daily).filter((d) => d.date > dateFrom && d.date < today00h);
                      d0.groupByAndSum("Sum", "WW", "MM")
                        .getLast(5)
                        .reverse()
                        .forEach((m) => {
                          this.weeklyData_labels.push(DataManager.MonthNamesShort[m.MM]);
                          this.weeklyData_values.push(m.Sum);
                        });

                      dateFrom = new Date(now.getFullYear(), now.getMonth()).getDateWithoutTime();
                      this.sumsData.monthly = d0
                        .filter((d) => d.date > dateFrom)
                        .map((d) => d.Sum)
                        .sum();

                      dateFrom = now.addDays(-8);
                      d0.filter((d) => d.date > dateFrom)
                        .groupByAndSum("Sum", "DWT")
                        .getLast(7)
                        .reverse()
                        .forEach((d) => {
                          this.dailyData_labels.push(d.DWT.toStringWithFormat("dd.MM"));
                          this.dailyData_values.push(d.Sum);
                        });

                      //dateFrom = this.getMonday(now);
                      dateFrom = now.getMonday();
                      this.sumsData.weekly = d0
                        .filter((d) => d.MONDAY.getTime() == dateFrom.getTime())
                        .map((d) => d.Sum)
                        .sum();

                      DataManager.loadData(DataManager.DataType.sales, (err3) => {
                        if (err3.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
                          var d0 = DataManager.getData(DataManager.DataType.sales, true);
                          var dateFrom = now.getDateWithoutTime();
                          this.sumsData.daily = d0
                            .filter((d) => d.rcp.date > dateFrom)
                            .map((s) => s.Sum)
                            .sum();

                          var hourlyData = d0.filter((d) => d.rcp.date > dateFrom).groupByAndSum("Sum", "HH");
                          var tmm = hourlyData.map((h) => h.HH);
                          var min = Math.min(...tmm);
                          var max = Math.max(...tmm);
                          if (min + 8 < max) {
                            min = max - 8;
                          }
                          for (var i = min; i <= max; i++) {
                            var hd = hourlyData.find((t) => t.HH == i);
                            var sum = 0;
                            if (hd) sum = hd.Sum;
                            this.hourlyData_values.push(sum);
                            this.hourlyData_labels.push(i);
                          }
                        } else {
                          this.message = err3.Message;
                        }
                        this.isRefreshing = false;
                      });
                    } else {
                      this.message = err2.Message;
                    }
                  });
                } else {
                  this.message = error.Message;
                }
                g_Dialog.close();
              },
              false,
              dateFrom,
              dateTo
            );
          });
        });
    },
    /**
     * @param {DataManager.DataType} datatype
     * @param {ErrorMessage} error
     */
    setTitleAndData(meta, error) {
      this.datatype = meta.datatype;
      this.title = meta.title;
      if (error.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
        this.refreshData();
      } else {
        this.message = error.Message;
      }
    },
    getMonday(d) {
      d = new Date(d);
      var day = d.getDay(),
        diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
      return new Date(d.setDate(diff));
    },
  },
  computed: {
    graphsGradiend() {
      return this.isInDarkMode ? ["#F11D28", "#FD3A2D", "#FE612C", "#FF872C", "#FFA12C"] : ["#010280", "#061993", "#0C3BAA", "#135CC5", "#1973D1"];
    },
  },
  created() {
    bus.$on(bus.EVENT_DataManager_DATA_CHANGED, (datatype) => {
      if (datatype == DataManager.DataType.sales || datatype == DataManager.DataType.devices) {
        this.refreshData();
      }
    });
    bus.$on(bus.EVENT_DataManager_FILTERS_CHANGED, (datatype) => {
      if (datatype == DataManager.DataType.devices) {
        this.refreshData();
      }
    });
  },
  mounted() {},
};
</script>

<style scoped>
.v-sheet--offset {
  top: -45px;
  position: relative;
}

div >>> svg >>> * >>> text,
div >>> svg >>> text {
  overflow-wrap: break-word;
  word-break: break-all;
  word-wrap: break-word;
}
</style>
